import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, registrar } from '../../services/authService';
import "./AuthPage.scss";

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);

  const toggleForm = () => {
    setIsLogin(!isLogin);
  };

  const handleRegistroSucesso = () => {
    setIsLogin(true);
  };

  const LoginForm = () => {
    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const [mensagem, setMensagem] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const { token } = await login({ email, senha });
        localStorage.setItem("token", token);
        setMensagem("Login bem-sucedido!");
        navigate("/home");
      } catch (error) {
        setMensagem("Erro ao fazer login: " + error.message);
      }
    };

    return (
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email"></label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Digite seu email"
            required
          />
        </div>
        <div className="form-group senha-container">
          <label htmlFor="senha"></label>
           <input
             type={showPassword ? "text" : "password"}
            id="senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            placeholder="Digite sua senha"
            required
          />
          <button
            type="button"
            className="toggle-password"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "🙈" : "🐵"} {/* Ícone para alternar */}
          </button>
        </div>
        <button type="submit">ENTRAR</button>
        {mensagem && (
          <p className={`message ${mensagem.includes('sucesso') ? 'success' : 'error'}`}>
            {mensagem}
          </p>
        )}
      </form>
    );
  };

  const RegistroForm = ({ onRegistroSucesso }) => {
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [telefone, setTelefone] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        await registrar({ nome, email, senha, telefone });
        setMensagem('Registro concluído! Faça login para continuar.');
        if (onRegistroSucesso) {
          onRegistroSucesso();
        }
      } catch (error) {
        setMensagem('Erro ao registrar: ' + error.message);
      }
    };

    return (
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="nome"></label>
          <input
            type="text"
            id="nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            placeholder="Digite seu nome"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email"></label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Digite seu email"
            required
          />
        </div>
        <div className="form-group senha-container">
          <label htmlFor="senha"></label>
          <input
            type={showPassword ? "text" : "password"}
            id="senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            placeholder="Digite sua senha"
            required
          />
          <button
            type="button"
            className="toggle-password"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "🙈" : "🐵"} {/* Ícone para alternar */}
          </button>
        </div>
        <div className="form-group">
          <label htmlFor="telefone"></label>
          <input
            type="text"
            id="telefone"
            value={telefone}
            onChange={(e) => setTelefone(e.target.value)}
            placeholder="Digite seu telefone"
          />
        </div>
        <button type="submit">Registrar</button>
        {mensagem && (
          <p className={`message ${mensagem.includes('concluído') ? 'success' : 'error'}`}>
            {mensagem}
          </p>
        )}
      </form>
    );
  };

  return (
    <div className="auth-container">
      <div className="form-wrapper">
        <img src="/DoseCerta.png" alt="Logo Dose Certa" className="logo" />
        <h1>{isLogin ? 'Login' : 'Registro'}</h1>
        {isLogin ? <LoginForm /> : <RegistroForm onRegistroSucesso={handleRegistroSucesso} />}
        <button 
          onClick={toggleForm} 
          className="toggle-button"
        >
          {isLogin ? 'CRIAR CONTA' : 'Ir para Login'}
        </button>
      </div>
    </div>
  );
};


export default AuthPage;